/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useMemo } from "react";
import Container from "../../../../components/Container/Container";
import TeamSection from "../../../../components/Sections/Generic/TeamSection/TeamSection";
import Layout from "../../../Layouts/Layout";
import PartnerLogoSection from "../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import BirdMapSection from "../../../../components/Sections/Divorce/BirdMapSection/BirdMapSection";
import DivorcePlannerSection from "../../../../components/Sections/Divorce/DivorcePlannerSection/DivorcePlannerSection";
import TrustSection from "../../../../components/Sections/Generic/TrustSection/TrustSection";
import LandingPageTeaser from "../../../../components/Teaser/LandingPageTeaser";
import ServiceSection from "../../../../components/Sections/Generic/ServiceSection/ServiceSection";
import AdvantagesLegalbirdAttorneySection from "../../../../components/Sections/Generic/AdvantagesLegalbirdAttorneySection/AdvantagesLegalbirdAttorneySection";
import ProcedureDivorceSection from "../../../../components/Sections/Divorce/ProcedureDivorceSection/ProcedureDivorceSection";
import KindsOfDivorceSection from "../../../../components/Sections/Divorce/KindsOfDivorceSection/KindsOfDivorceSection";
import DivorcePartnerCheckin from "../../../../components/Checkin/FamilyLawCheckin/Divorce/DivorcePartnerCheckin";
import ServiceTeaser from "../../../../components/Teaser/ServiceTeaser";
import LpDivorceAdvoCardMeta from "./AdvoCard/LpDivorceAdvoCardMeta";
import LpDivorceAragMeta from "./Arag/LpDivorceAragMeta";
import LpDivorceRolandMeta from "./Roland/LpDivorceRolandMeta";
import GreyBackgroundWrapper from "../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import LinkedCardBox from "../../../../components/LinkedCardBox/LinkedCardBox";
import { defaultProvenExpertTeaserCard } from "../../../../services/landingPageService";
import iconAttorneys from "../../../../assets/icons/generic/IconLawyers";
import costsSecureIcon from "../../../../assets/icons/generic/IconCostSecurity";
import { useCustomer } from "../../../../provider/Customer/CustomerProvider";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

const getMetaDataByPartner = ({ partner }: { partner: string }) => {
  switch (partner) {
    case "advocard":
      return <LpDivorceAdvoCardMeta />;
    case "arag":
      return <LpDivorceAragMeta />;
    case "roland":
      return <LpDivorceRolandMeta />;
    default:
      return null;
  }
};

const LpDivorcePartner = ({ partner }: { partner: NonNullable<AbstractCase["acquisitionPartner"]> }) => {
  const { isLoggedIn } = useCustomer();
  const metaData = useMemo(() => getMetaDataByPartner({ partner }), [partner]);

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      {metaData}
      <LandingPageTeaser
        headline={"Professionell scheiden lassen"}
        subheadline={"Wir begleiten Sie sicher bei Ihrer Scheidung."}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox
          linkedCards={[
            defaultProvenExpertTeaserCard,
            {
              icon: iconAttorneys,
              heading: "Professionelle Beratung",
            },
            {
                icon: costsSecureIcon,
              heading: "Nirgendwo günstiger",
            },
          ]}
        />
      </LandingPageTeaser>
      <PartnerLogoSection partnerName={partner} containerStyle={"settlementContainer"} />
      <GreyBackgroundWrapper>
        <Container>{!isLoggedIn && <DivorcePartnerCheckin idPrefix={"top"} partner={partner} />}</Container>
        <KindsOfDivorceSection />
        <ServiceSection product={"divorce"} />
        <TeamSection isSubsection={true} />
      </GreyBackgroundWrapper>
      <BirdMapSection />
      <AdvantagesLegalbirdAttorneySection />
      <ServiceTeaser />
      <GreyBackgroundWrapper>
        <DivorcePlannerSection />
        <ProcedureDivorceSection />
      </GreyBackgroundWrapper>
      <TrustSection showCoopPress={false} />
      <Container>{!isLoggedIn && <DivorcePartnerCheckin idPrefix={"top"} partner={partner} />}</Container>
    </Layout>
  );
};

export default LpDivorcePartner;
